import api from "./api.service";

const API_SUFFIX = process.env.VUE_APP_API_SUFFIX;

export default class extends api {
  static scenarios(
    startAt = 0,
    numberToGet = 10,
    patientAge = -1,
    patientCondition = -1,
    searchTerm = -1,
    tags = -1
  ) {
    let commaDelimTags = -1;
    if (tags.length > 0) {
      commaDelimTags = tags.join(",");
    }
    return this.apiRequest(
      API_SUFFIX +
        "/api/scenarios/" +
        startAt +
        "/" +
        numberToGet +
        "/" +
        patientAge +
        "/" +
        patientCondition +
        "/" +
        searchTerm +
        "/" +
        commaDelimTags,
      {},
      "GET"
    );
  }

  static getUsersPublicScenarios(userId) {
    return this.apiRequest(
      API_SUFFIX + "/api/scenarios/userpublic/" + userId,
      {},
      "GET"
    );
  }

  static scenario(uuidId) {
    return this.apiRequest(API_SUFFIX + "/api/scenarios/" + uuidId, {}, "GET");
  }

  static myScenarios(
    startAt = 0,
    numberToGet = 10,
    sortBy = "isProcessed",
    sortDirection = "DESC",
    directoryUuid = null
  ) {
    let url = `${API_SUFFIX}/api/scenarios/myscenarios/${startAt}/${numberToGet}/${sortBy}/${sortDirection}/`;
    if (directoryUuid) url += directoryUuid;

    return this.apiRequest(url, {}, "GET");
  }

  static myUnpostedScenarios(startAt = 0, numberToGet = 10) {
    return this.apiRequest(
      `${API_SUFFIX}/api/scenarios/myunpostedscenarios/${startAt}/${numberToGet}`,
      {},
      "GET"
    );
  }

  static scenarioTags() {
    return this.apiRequest(API_SUFFIX + "/api/alltags", {}, "GET");
  }

  static favouritedScenarios() {
    return this.apiRequest(
      API_SUFFIX + "/api/scenarios/myfavourites",
      {},
      "GET"
    );
  }

  static toggleFavouriteScenario(scenarioId) {
    return this.apiRequest(
      API_SUFFIX + "/api/scenarios/togglefavourite/" + scenarioId,
      {},
      "POST"
    );
  }

  static editScenario(data, scenarioUuidId) {
    return this.apiRequest(
      API_SUFFIX + "/api/scenarios/edit/" + scenarioUuidId,
      data,
      "PATCH"
    );
  }

  static uploadScenario(formData) {
    return this.apiRequest(
      API_SUFFIX + "/api/scenarios/upload",
      formData,
      "POST",
      true
    );
  }

  static deleteScenario(scenarioId) {
    return this.apiRequest(
      API_SUFFIX + "/api/scenarios/delete/" + scenarioId,
      {},
      "DELETE"
    );
  }

  static getUsersFavouritedScenarios(userId) {
    return this.apiRequest(
      API_SUFFIX + "/api/scenarios/userfavourites/" + userId,
      {},
      "GET"
    );
  }

  static downloadScenario(scenarioUuidId) {
    return this.apiRequest(
      API_SUFFIX + "/api/scenarios/download/" + scenarioUuidId,
      {},
      "GET"
    );
  }

  static copyToMyScenarios(scenarioUuid) {
    return this.apiRequest(
      API_SUFFIX + "/api/scenarios/copy/" + scenarioUuid,
      {},
      "POST"
    );
  }

  static getDirectoryContents(directoryUuid) {
    return this.apiRequest(
      API_SUFFIX + "/api/scenarios/GetDirectoryContents/" + directoryUuid,
      {},
      "GET"
    );
  }

  static getDirectoryTree() {
    return this.apiRequest(
      API_SUFFIX + "/api/scenarios/GetDirectoryTree",
      {},
      "GET"
    );
  }
}
